import { AlertController, ModalController, NavController, MenuController } from 'ionic-angular';
import { MeteorObservable } from 'meteor-rxjs';
import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { conformToMask } from 'angular2-text-mask'
import { Companies, Updates, Projects } from 'api/collections';
import { Company, Project, User, Update } from 'api/models';
import { CompanyPage } from '../../pages/company/company';
import { ProjectHomePage } from '../../pages/project-home/project-home';
import { ChooseActiveProjectPage } from '../../components/choose-active-project/choose-active-project';
import { AllCompaniesPage } from '../../pages/all-companies/all-companies';
import { UserProfilePage } from '../../pages/user-profile/user-profile';

import { SupportComponent } from '../../pages/support/support';
import { AppVersion } from '@ionic-native/app-version';

// import { subscribeActiveProject } from '../../services/projectData';
import { ProjectService } from '../../services/projectData';
// import { subscribeActiveCompany, getCompany, getUserCompanies } from '../../services/companyData';
import { CompanyService } from '../../services/companyData';
import { HttpService } from '../../services/httpService';

import { logout } from '../../services/logout';
import * as permissions from '../../services/permissions';
import { AuthenticationService } from '../../services/congito';
import { LoginComponent } from '../../pages/auth/login/login.component';
import { SharedService } from '../../services/sharedService';

@Component({
  selector: 'side-menu',
  templateUrl: 'side_menu.html',
})
export class SideMenu implements OnInit {
  @Input() nav: NavController;
  viewer: User;
  viewerEmail: string | void;
  activeCompany: Company | void;
  viewerCompanies: Company[]=[];
  activeProject: Project | void;
  activeProjectCompany: Company | void;
  selectedUpdate: Update | void;
  isSuperAdmin: boolean;
  refreshParams:any;

  constructor(
    private alertCtrl: AlertController,
    private menuCtrl: MenuController,
    private modalCtrl: ModalController,
    private appVersion: AppVersion,
    public httpService: HttpService,
    public companyService: CompanyService,
    public projectService: ProjectService,
    private sharedService: SharedService,
    public authenticationService: AuthenticationService,
    private router: Router
  ) {
  }

  async setStuff(){
    this.viewer = this.authenticationService.MeteorUser() as User;
    this.isSuperAdmin = permissions.isSuperAdmin(this.viewer);
    this.viewerEmail = _.get(this.viewer, 'emails[0].address');
    this.activeCompany = this.companyService.subscribeActiveCompany();
    this.activeProject = this.projectService.subscribeActiveProject();
    this.activeProjectCompany = this.activeProject ? this.companyService.getCompany(this.activeProject.companyId) : null;
    this.viewerCompanies = this.companyService.getUserCompanies(this.viewer);
      /** App Versions */
      
  }


  ngOnInit() {

  this.httpService.MeteorSubscribe('userData')
    .then(res=>this.httpService.MeteorSubscribe('allCompanies'))
    .then(res=>this.httpService.MeteorSubscribe('userCompanies'))
    .then(()=>this.httpService.privateLoopAction(true))
      .then(() => this.setStuff())
      .catch(err => console.log('meteor subscribe error:', err));
    
    const interval = setInterval(async ()=>{
      const currentUser=(await this.authenticationService.MeteorUser()) as User;
      
      if(this.activeProject){
        clearInterval(interval);
        this.setStuff();
      } else {
        return this.httpService.MeteorSubscribe('userData')
        .then(res=>this.httpService.MeteorSubscribe('allCompanies'))
        .then(res=>this.httpService.MeteorSubscribe('userCompanies'))
        .then(()=>this.httpService.privateLoopAction(true))
          .then(() => this.setStuff())
      }

    }, 1000);

    this.sharedService.projectChanged.subscribe((project: any) => {
      this.refreshParams={projectId:project._id};
      this.setStuff();
      if(project.goToAppHome){
        alert();
        this.goToAppHome();
      }
    });

    this.sharedService.login.subscribe(()=>{
      this.httpService.MeteorSubscribe('userData')
      .then(res=>this.httpService.MeteorSubscribe('allCompanies'))
      .then(res=>this.httpService.MeteorSubscribe('userCompanies'))
      .then(()=>this.httpService.privateLoopAction(true))
      .then(() => {
        this.setStuff();
      })
      .catch(err => console.log('meteor subscribe error:', err));
    });
  }

  formatPhoneNumber(phoneNumberStr: void|string): string {
    const phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    return conformToMask(phoneNumberStr || '', phoneMask, {guide:false}).conformedValue;
  }

  logout() {
    this.router.navigate(['/logout']);
    logout(this.alertCtrl, this.httpService).then(async res=>{
      if(res){
        await this.nav.setRoot(LoginComponent);
        this.menuCtrl.close();
      }
    });

  }

  goToCompany() {
    this.nav.setRoot(CompanyPage);
    this.menuCtrl.close();
  }

  goToAegisIT() {
    this.nav.setRoot(AllCompaniesPage);
    this.menuCtrl.close();
  }

  goToAppHome() {

    this.nav.setRoot(ProjectHomePage, this.refreshParams);
    this.menuCtrl.close();
  }

  goToEditProfile() {
    // Get the current URL, so that we can return to it, when the modal is closed
    const currentURL = this.router.url;

    const modal = this.modalCtrl.create(UserProfilePage);
    modal.present();
    this.router.navigate(['/editProfile']);

    modal.onDidDismiss( () => {
      // Display the original URL, that shown prior to modal open
      this.router.navigate ([currentURL])
    });
  }

  goToSupport(event): void {
    event.preventDefault();
    // Get the current URL, so that we can return to it, when the modal is closed
    const currentURL = this.router.url;
    const modal = this.modalCtrl.create(SupportComponent);
    modal.present();
    this.router.navigate(['/contactSupport']);

    modal.onDidDismiss( () => {
      if (currentURL) {
        // Display the original URL, that shown prior to modal open
        this.router.navigate ([currentURL]);
      }
    });
  }

  goToChooseActiveProject(event): void {
    event.preventDefault();
    event.stopPropagation();
    // Get the current URL, so that if the project is not changed, we can return to it, when the modal is closed
    const currentURL = this.router.url;
    const modal = this.modalCtrl.create(ChooseActiveProjectPage);
    modal.present();
    // this.router.navigate(['/changeProject']);
    
    modal.onDidDismiss( () => {
      if (this.router.url =='/changeProject') {
        // The project is unchanged, so display the original URL, that shown prior to modal open
        this.router.navigate ([currentURL]);
      }
    })
  }

  isActiveCompanyAdmin(): boolean {
    if (!this.activeCompany) {
      return false;
    }

    return permissions.isCompanyAdmin(this.activeCompany, this.authenticationService.MeteorUser());
  }

}



// WEBPACK FOOTER //
// ./src/directives/side_menu/side_menu.component.ts